module.exports = __webpack_public_path__ + "static/img/new_icon_1_preview.27e2705.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/newImages/new_icon_1_preview.png
// module id = 1407
// module chunks = 4